<script setup lang="ts">
import Toast from './Toast.vue'
import ToastClose from './ToastClose.vue'
import ToastDescription from './ToastDescription.vue'
import ToastProvider from './ToastProvider.vue'
import ToastTitle from './ToastTitle.vue'
import ToastViewport from './ToastViewport.vue'
import {useToast} from './useToast'

const {toasts, dismiss} = useToast()
</script>

<template>
  <ToastProvider>
    <Toast
      v-for="item in toasts"
      :key="item.id"
      :variant="item.variant"
      :duration="item.duration ?? 4000"
      @update:open="(open) => !open && dismiss(item.id)">
      <div class="grid gap-1">
        <ToastTitle v-if="item.title">{{ item.title }}</ToastTitle>
        <ToastDescription v-if="item.description || item.title">{{ item.description || item.title }}</ToastDescription>
      </div>
      <ToastClose />
    </Toast>
    <ToastViewport />
  </ToastProvider>
</template>
